var exports = {
  "V1": "sidePanelWrapper__bfXyDD",
  "Gj": "sidePanelLayout__Y3re7J",
  "AW": "sidePanelMainContent__910e0o",
  "YB": "sidePanelContentContainer__rMsshR",
  "rE": "sidePanelPaneSettings__CXe0uY",
  "o0": "sidePanelPane__nAqgOQ",
  "Qm": "smallViewport__I3Si-9",
};

module.exports = exports;
